import cn from "classnames";
import { ReactNode } from "react";

interface SectionContentWrapperProps {
    children: ReactNode;
    className?: string;
    withBackground?: boolean;
}

export const SectionContentWrapper = (props: SectionContentWrapperProps) => {
    return (
        <div className={cn(props.className, props.withBackground && "bg-white p-5 rounded-lg break-inside-avoid")}>
            {props.children}
        </div>
    );
};
